import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector: React.FC = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const [detectedLanguage, setDetectedLanguage] = useState<string>('');
  const [showDetectedBadge, setShowDetectedBadge] = useState(true);

  useEffect(() => {
    // Get browser language
    const browserLang = navigator.language.split('-')[0];
    setDetectedLanguage(browserLang);
    
    // Hide the badge after 5 seconds
    const timer = setTimeout(() => {
      setShowDetectedBadge(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'es', name: 'Español' },
    { code: 'pt', name: 'Português' }
  ];

  return (
    <div className="relative inline-block text-left group">
      <button
        type="button"
        className="inline-flex items-center justify-center p-2 rounded-full text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none relative"
        aria-expanded="true"
        aria-haspopup="true"
      >
        <Globe className="h-5 w-5" />
        <span className="ml-1 text-sm hidden sm:inline">
          {languages.find(lang => lang.code === currentLanguage)?.name}
        </span>
        {showDetectedBadge && detectedLanguage && (
          <div className="absolute -top-2 -right-2 bg-blue-500 text-white text-xs px-2 py-0.5 rounded-full">
            {detectedLanguage}
          </div>
        )}
      </button>

      <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300">
        <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => changeLanguage(language.code as any)}
              className={`block w-full text-left px-4 py-2 text-sm ${
                currentLanguage === language.code ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
              } hover:bg-gray-100 hover:text-gray-900`}
              role="menuitem"
            >
              {language.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;